export default function VerifyEmailModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/65 flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
            <div className="glass-strong max-w-md w-full p-6 relative animate-in zoom-in-95 duration-200">
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 btn-ghost px-2 py-2 text-slate-300 hover:text-slate-100"
                    aria-label="Close"
                >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Icon */}
                <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-[0_16px_30px_-20px_rgba(251,191,36,0.70)] border border-white/10">
                    <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                </div>

                {/* Content */}
                <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50 text-center mb-2">
                    Verify Your Email
                </h2>
                <p className="text-slate-600 dark:text-slate-300 text-center mb-6">
                    To download your icons, you first need to verify your email address. Please check your inbox for a verification link.
                </p>

                {/* Buttons */}
                <div className="space-y-3">
                    <button
                        onClick={onClose}
                        className="w-full btn-primary py-3"
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}
